// extracted by mini-css-extract-plugin
module.exports = {"container":"EventSummaryDocument_container__2o9G4"};